/** `current` followed by the items of `added` whose id it does not already hold. */
export const mergeById = (current, added) => {
    const list = current || [];
    const ids = new Set(list.map((item) => item.id));
    return [...list, ...added.filter((item) => !ids.has(item.id))];
};
